export const CLIENT_ICON_EVENT = "client-icon:updated";

export function setClientIconUrl(iconUrl) {
  if (iconUrl) {
    localStorage.setItem("clientIconUrl", iconUrl);
  } else {
    localStorage.removeItem("clientIconUrl");
  }

  if (typeof window !== "undefined" && window.dispatchEvent) {
    window.dispatchEvent(
      new CustomEvent(CLIENT_ICON_EVENT, {
        detail: { iconUrl: iconUrl || null },
      })
    );
  }
}
